import { createSlice } from "@reduxjs/toolkit";
import { getDeliveryOrderList, getDeliveryOrderByID } from "./deliveryOrderNumberAction";

const deliveryorderSlice = createSlice({
    name: "deliveryorder",
    initialState: {
        error: "Sorry! No Data Found.",
        message: null,
        loading: false,        
        unitsLoading: false,
        model: false,
        error_msg: null,
        rowdata: {},
        listCount: 0,
        deliveryorderlist: [],
        deliveryorderParams: {
            no_of_pages: 0,
            page_size: 10,
            page: 1,
            search: "",
            currentSort: "code",
            sortOrder: "-",
        },
        
    },
    reducers: {
       
        InputChangeValue: (state, action) => {
            return {
                ...state,
                rowdata: {
                    ...state.rowdata,
                    [action.payload.key]: action.payload.value,
                },
            };
        },   
        SetDeliveryOrderParams: (state, action) => {
            return {
                ...state,
                deliveryorderParams: {
                    ...state.deliveryorderParams,
                    ...action.payload
                },
            };
        },
        isModelVisible: (state, action) => {
            if (!action.payload) {
                return {
                    ...state,
                    model: action.payload,
                    rowdata: {},
                };
            } else {
                return {
                    ...state,
                    model: action.payload,
                };
            }
        },
    },
    extraReducers: (builder) => {
        builder
            .addCase(getDeliveryOrderList.pending, (state, action) => {
                state.status = "getDeliveryOrderList loading";
                state.loading = true;
            })
            .addCase(getDeliveryOrderList.fulfilled, (state, action) => {
                console.log(action.payload.response)
                state.status = "getDeliveryOrderList succeeded";
                state.loading = false;
                var response = action.payload.response;
                var noofpages = Math.ceil(
                    action.payload.count / state.deliveryorderParams?.page_size
                );

                state.deliveryorderlist = response.results;
                state.listCount = response.count;
                state.deliveryorderParams = {
                    ...state.deliveryorderParams,
                    no_of_pages: noofpages,
                };
            })
            .addCase(getDeliveryOrderList.rejected, (state, action) => {
                state.status = "getDeliveryOrderList failed";
                state.loading = false;
                state.error = action.error.message;
            })
            
            .addCase(getDeliveryOrderByID.pending, (state, action) => {
                state.status = "getDeliveryOrderByID loading";
                state.loading = true;
            })
            .addCase(getDeliveryOrderByID.fulfilled, (state, action) => {
                state.status = "getDeliveryOrderByID succeeded";
                state.loading = false
                state.rowdata = action.payload;
            }
            )
            .addCase(getDeliveryOrderByID.rejected, (state, action) => {
                state.status = "getDeliveryOrderByID failed";
                state.loading = false;
                state.error = action.error.message;
            })
           
    }

});
export const {
    InputChangeValue,
    SetDeliveryOrderParams,
    isModelVisible
} = deliveryorderSlice.actions;

export default deliveryorderSlice.reducer;